export const apiRoutes = {
  getExternalUsers: () => '/users/external',
};
